module.exports = __webpack_public_path__ + "static/media/out-of-stock.29e1294a.svg";